import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useUserRoles from '../../hooks/Home/useUserRoles';
import { usePermissionsContext } from '../../context/PermissionsContext';
import { tokenStorage } from '../../utils/encryptedCookie';

const ProtectedRoute = ({ children, requiredRole, requiredPermission }) => {
  const token = tokenStorage.get();
  const location = useLocation();
  const roles = useUserRoles();
  const { permissions, hasPermission } = usePermissionsContext();

  if (!token) {
    if (location.pathname !== '/login') {
      return <Navigate to="/login" replace />;
    }
  }

  const hasAdminRole = roles.includes('ADMIN');
  
  if (requiredPermission) {
    const hasAnyPermissions = Object.keys(permissions).length > 0;
    const canAccess = hasAnyPermissions ? hasPermission(requiredPermission) : hasAdminRole;
    if (!canAccess) {
      return <Navigate to="/romaneios" replace />;
    }
  }

  if (requiredRole && !roles.includes(requiredRole)) {
    const hasAnyPermissions = Object.keys(permissions).length > 0;
    if (hasAnyPermissions) {
      return <Navigate to="/romaneios" replace />;
    }
    return <Navigate to="/romaneios" replace />;
  }

  return children;
};

export default ProtectedRoute;